import React, { ReactNode } from 'react';
import { Card, CardProps } from '@sm/wds-react';
import { LogoWithText } from '../Logos';
import './captive-window.scss';
import Footer from './Footer';

export type CaptiveWindowProps = Pick<CardProps, 'children'> &
  Partial<Pick<CardProps, 'className'>> & {
    /** Optional content placed between the logo and the card */
    addOnTop?: ReactNode;
    logoPosition?: 'auto' | 'center';
  };

const CaptiveWindow: React.FC<CaptiveWindowProps> = ({
  addOnTop = null,
  logoPosition = 'auto',
  ...rest
}) => {
  const headerClassName = [
    'sm-logo__header',
    logoPosition === 'center' ? 'sm-logo__header__center' : '',
  ].join(' ');

  return (
    <div className="sm-captive-window__page wds-flex wds-flex--y wds-flex--x-center">
      <div className="sm-captive-window__section">
        <header className={headerClassName}>
          <LogoWithText className="sm-logo__logo" />
        </header>

        {addOnTop}

        <Card {...rest} />
      </div>
      <div className="sm-captive-window__section">
        <Footer />
      </div>
    </div>
  );
};

export default CaptiveWindow;
